import React from 'react';

import { HiddenInput as Props } from './hidden-input.types';

const HiddenInput: React.FunctionComponent<Props> = props => (
  <input type="hidden" {...props} />
);

export default HiddenInput;
